<script setup lang="ts">
import type { GrammarMessageStatusBarMessageStatus } from './component-types';

export interface GrammarMessageStatusBarProps {
  messageStatus?: GrammarMessageStatusBarMessageStatus;
  direction?: 'leading' | 'trailing' | 'mid-leading' | 'mid-trailing';
  value?: number;
}

const props = withDefaults(defineProps<GrammarMessageStatusBarProps>(), {
  messageStatus: 'received',
  direction: 'leading',
  value: 0,
});
</script>

<template>
  <tpg-message-status-bar v-bind="props" />
</template>
